import theme from '@styles/theme';
export default {
  productCardInfoSwatches: {
    display: 'flex',
    flexDirection: 'row',
    mt: '12px',
    alignItems: 'center'
  },
  productCardInfoSwatch: (background?: string, color?: string) => {
    let swatchBackground = {};
    if (background) {
      swatchBackground = {
        background: `url(${background})`,
        backgroundPosition: 'center',
        backgroundSize: 'fill'
      };
    }
    if (color) {
      swatchBackground = {
        ...swatchBackground,
        backgroundColor: color
      };
    }
    return {
      borderRadius: '50%',
      border: `0.1px solid  ${theme.rawColors.lightGreyBorder}`,
      ...swatchBackground,
      display: 'inline-flex',
      width: '16px',
      height: '16px',
      mr: '7px'
    };
  }
};